<div class="h-full flex flex-col justify-between">
    <div
        #detailDiv
        class="detail panel-content">
        <div
            class="flex flex-wrap gap-4"
            [class]="isWide() ? 'flex-row justify-between items-start' : 'flex-col'">
            <div>
                <app-title
                    class="header-title font-medium text-2xl"
                    [title]="title()"
                    (goToPreviousPage)="closeSymbology()" />
                <p class="font-medium text-base pt-2 pl-12">
                    {{ labelByLayerType[Layer.TypeEnum.TABLE] | transloco: { COUNT: 1 } }}
                </p>
            </div>

            <div
                class="flex flex-col"
                [class]="isWide() ? 'self-center pr-2' : 'items-start pl-2'">
                <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                    {{ 'identifierColumn' | transloco }}
                </p>
                <p class="!m-0">{{ businessIdentifier() ?? '-' }}</p>
            </div>
        </div>

        <div class="flex-1 flex flex-col min-h-0">
            @if (formStyleLoaded()) {
                <form [formGroup]="symbologyEditService.formGroup">
                    <app-symbology-geometry-form
                        title="Points"
                        [formGroup]="symbologyEditService.pointFormGroup"
                        [geometry]="MapboxStyle.TypeEnum.SYMBOL"
                        [isWide]="isWide()"
                        (addForm)="symbologyEditService.addPointForm()"
                        (removeForm)="symbologyEditService.removePointForm()" />
                    <app-symbology-geometry-form
                        [formGroup]="symbologyEditService.lineFormGroup"
                        [geometry]="MapboxStyle.TypeEnum.LINE"
                        [isWide]="isWide()"
                        [title]="'line' | transloco"
                        (addForm)="symbologyEditService.addLineForm()"
                        (removeForm)="symbologyEditService.removeLineForm()" />
                    <app-symbology-geometry-form
                        [formGroup]="symbologyEditService.polygonFormGroup"
                        [geometry]="MapboxStyle.TypeEnum.FILL"
                        [isWide]="isWide()"
                        [title]="'polygon' | transloco"
                        (addForm)="symbologyEditService.addPolygonForm()"
                        (removeForm)="symbologyEditService.removePolygonForm()" />
                </form>
            } @else {
                <app-loading />
            }
        </div>
    </div>
    <div class="footer justify-end gap-2">
        @if (symbologyEditService.formGroup) {
            @if (symbologyEditService.isPreviewActive()) {
                <app-button
                    iconSize="xl"
                    [icon]="['fas', 'rotate']"
                    [tooltip]="'previewRefresh' | transloco"
                    [type]="ButtonType.SECONDARY"
                    (onClick)="symbologyEditService.previewStyle()" />
            }
            <app-button
                iconSize="sm"
                [disabled]="
                    !symbologyEditService.formGroup.valid ||
                    symbologyEditService.formGroup.pristine ||
                    symbologyEditService.isFormEmpty()
                "
                [icon]="['fas', symbologyEditService.isPreviewActive() ? 'eye-slash' : 'eye']"
                [label]="(symbologyEditService.isPreviewActive() ? 'previewExit' : 'preview') | transloco"
                [tooltip]="
                    symbologyEditService.formGroup.valid || symbologyEditService.formGroup.pristine
                        ? ('previewRefresh' | transloco)
                        : undefined
                "
                [type]="ButtonType.SECONDARY"
                (onClick)="symbologyEditService.previewStyle(symbologyEditService.isPreviewActive())" />
            <app-button
                iconSize="sm"
                [disabled]="
                    !symbologyEditService.formGroup.valid ||
                    symbologyEditService.formGroup.pristine ||
                    symbologyEditService.isFormEmpty()
                "
                [icon]="['fas', 'pen']"
                [label]="'submit' | transloco"
                [tooltip]="!symbologyEditService.isFormEmpty() ? ('warningAtLeastOneStyle' | transloco) : undefined"
                [type]="ButtonType.PRIMARY"
                (onClick)="symbologyEditService.submit()" />
        }
    </div>
</div>
